import { Fragment } from 'react';
import Headline from '../../../../components/Headline';
import Description from '../../../../components/Description';
import Uploader from './Uploader';

const Logo = () => (
  <Fragment>
    <Headline message='Integration your logo headline' />

    <Description message='Integration your logo description' />

    <Uploader />
  </Fragment>
);

export default Logo;
